<template>
  <div id="header" ref="fixedHeader">
    <div class="top_header">
      <div class="size clear">
        <top-header></top-header>
      </div>
    </div>
    <div id="fixed_header" :class="addClassFixed ? 'fixed' : ''">
      <div class="size clear">
        <div class="all_btn">
          <a
            v-if="device === 'desktop'"
            role="button"
            class="pc"
            @click="showAllMenu = !showAllMenu"
          ></a>
          <a
            v-else
            role="button"
            class="mo"
            @click="$emit('update:showMobileHeader', true)"
          ></a>
        </div>
        <div class="h_logo mo">
          <router-link
            :to="{
              name: 'home'
            }"
            ><img src="@/assets/images/h_logo.png"
          /></router-link>
        </div>
        <div class="s_wrap">
          <div class="h_logo">
            <router-link
              :to="{
                name: 'home'
              }"
              ><img src="@/assets/images/h_logo.png"
            /></router-link>
          </div>
          <div class="search_wrap">
            <div class="search_box">
              <input
                v-model="searchText"
                type="text"
                id="sval"
                name="sval"
                title="검색어 입력"
                placeholder="검색어를 입력하여주세요. (상품코드 / 공급사코드 / 상품명)"
                @keydown.enter="getProductList"
                @click.capture="showSearchWrods = true"
                autocomplete="off"
              />
              <input
                type="button"
                id=""
                value="검색"
                title="검색"
                @click="getProductList"
              />
            </div>
            <transition name="fade">
              <div class="search_list" v-show="showSearchWrods">
                <div class="list_wrap">
                  <ul>
                    <li v-for="(word, index) in searchWordList" :key="index">
                      <a
                        role="button"
                        @click.capture="searchText = word"
                        @click="getProductList"
                        >{{ word }}</a
                      >
                      <a
                        role="button"
                        @click="deleteSearchWord(index)"
                        class="cls"
                        ><img src="@/assets/images/sr_cl.png"
                      /></a>
                    </li>
                  </ul>
                </div>
                <div class="btm_wrap clear">
                  <div class="list_del">
                    <a role="button" @click="emptySearchWord"
                      >최근 검색어 전체 삭제</a
                    >
                  </div>
                  <div class="list_cls">
                    <button @click="showSearchWrods = false">닫기</button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="gnb_wrap">
          <top-guide></top-guide>
          <div class="meb_ul ">
            <ul class="list_list clear" v-if="username">
              <li>
                <router-link
                  :to="{
                    name: 'productDownload',
                    params: { parentId: 2 }
                  }"
                  >상품DB다운로드</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'productUpdateList',
                    params: { parentId: 2 }
                  }"
                  >상품수정리스트</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'orderExcel',
                    params: { parentId: 1 }
                  }"
                  >엑셀주문</router-link
                >
              </li>
            </ul>
            <ul class="ico_list clear" v-if="username">
              <li class="arm">
                <router-link :to="{ name: 'alarm' }">
                  <span class="img">
                    <img src="@/assets/images/fixed_hico01.png" /><em>{{
                      alarmCount
                    }}</em></span
                  >
                </router-link>
              </li>
              <li class="crt">
                <router-link
                  :to="{
                    name: 'cart'
                  }"
                  ><span class="img"
                    ><img src="@/assets/images/fixed_hico02.png" /><em>{{
                      cartCount
                    }}</em></span
                  ></router-link
                >
              </li>
              <li class="mp">
                <router-link
                  :to="{
                    name: 'orderList',
                    params: { parentId: 0 }
                  }"
                >
                  <span class="img">
                    <img src="@/assets/images/fixed_hico03.png" />
                    <!--                    <em>Lv.1</em>-->
                  </span></router-link
                >
              </li>
            </ul>
            <ul class="ico_list clear" v-else>
              <li class="mp">
                <router-link
                  :to="{
                    name: 'login',
                    params: { parentId: null }
                  }"
                >
                  <span class="img">
                    <img src="@/assets/images/fixed_hico03.png" />
                    <!--                    <em>Lv.1</em>-->
                  </span></router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <transition name="fade">
          <div
            class="all_menu"
            v-show="showAllMenu"
            :style="
              'max-width:' + (allMenuWidth ? allMenuWidth + 'px' : 500 + 'px')
            "
          >
            <div class="wrap">
              <a role="button" class="close" @click="showAllMenu = false"></a>
              <div class="l_box">
                <ul>
                  <li
                    v-for="(category, index) in treeCategories"
                    :key="index"
                    :class="{ on: category.isOn }"
                    @mouseover="updateCategoryClass(index)"
                    @click="updateCategoryClass(index)"
                  >
                    <div class="tb">
                      <a role="button">
                        <p
                          class="pic"
                          :style="{
                            backgroundImage:
                              'url(' +
                              (category.isOn
                                ? category.onIcon
                                : category.menuIcon) +
                              ')'
                          }"
                        >
                          <img :src="category.menuIcon" />
                        </p>
                        <span>{{ category.name }}</span>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                class="r_box"
                v-for="(category, index) in treeCategories"
                :key="index"
                :class="index === activeCategoryIndex ? 'act' : ''"
                v-show="index === activeCategoryIndex"
              >
                <div
                  class="i_box"
                  v-for="(children, index) in category.loopCount"
                  :key="index"
                  style="vertical-align: top;"
                >
                  >
                  <b>{{ index === 0 ? category.name : '' }}</b>
                  <ul>
                    <li
                      v-for="child in category.children.slice(
                        index * 5,
                        index * 5 + 5
                      )"
                      :key="child.id"
                    >
                      <router-link
                        @click.native="closeAllMenu(child.wholeName)"
                        :to="{
                          name: 'productList',
                          params: { categoryName: child.wholeName }
                        }"
                      >
                        {{ child.name }}</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="btm_header">
      <div class="size clear">
        <div class="gnb">
          <ul>
            <li v-for="(item, index) in bottomMenu" :key="index">
              <router-link
                :to="{
                  name: item.url,
                  params: { parentId: item.parent_id }
                }"
                ><span> {{ item.name }}</span></router-link
              >
            </li>
          </ul>
        </div>
        <div class="gnb_sl">
          <div class="slide_wrap">
            <swiper ref="mySwiper2" :options="swiperOptions2">
              <swiper-slide v-for="(item, index) in bottomMenu" :key="index">
                <router-link
                  :to="{
                    name: item.url,
                    params: { parentId: item.parent_id }
                  }"
                  ><span> {{ item.name }}</span></router-link
                >
              </swiper-slide>
            </swiper>
            <div class="gnb_box">
              <div class="l_btn" slot="button-prev"></div>
              <div class="r_btn" slot="button-next"></div>
            </div>
          </div>
        </div>
        <div class="recom_sl">
          <swiper class="swiper" ref="mySwipe3" :options="swiperOptionsLeftTop">
            <swiper-slide
              v-for="(promotion_banner, index) in textBanner"
              v-bind:key="index"
            >
              <router-link :to="promotion_banner.url">
                <span>추천상품</span>
                <p>{{ promotion_banner.name }}</p>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { directive, Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import TopGuide from '../TopGuide'
import { advertiseList } from '@/api/homeData'

import { fetchTreeList } from '@/api/productCate'
import TopHeader from './components/TopHeader'
import { loadImage } from '@/utils'

export default {
  name: 'FixedHeader',
  props: {
    showMobileHeader: {
      default: false
    },
    windowTop: {
      default: 0
    },
    addClassFixed: {
      default: false
    },
    fixedHeight: {
      default: 0
    }
  },
  components: {
    TopHeader,
    Swiper,
    SwiperSlide,
    TopGuide
  },
  directives: {
    swiper: directive
  },
  computed: {
    ...mapGetters([
      'name',
      'username',
      'device',
      'memberLevelInfo',
      'cartCount',
      'alarmCount',
      'searchParams'
    ])
  },
  data() {
    return {
      showMyPage: false,
      swiperOptionsLeftTop: {
        direction: 'vertical',
        loop: true,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        height: 72
      },
      isDisplay: false,
      showAllMenu: false,
      allMenuWidth: 0,
      searchWordList: [],
      showSearchWrods: false,
      searchText: null,
      activeCategoryIndex: null,
      treeCategories: [
        {
          id: null,
          name: '',
          menuIcon: '',
          onIcon: '',
          backgroundIcon: '',
          icon: '',
          isOn: false,
          loopCount: 0,
          children: [
            {
              id: null,
              name: ''
            }
          ]
        }
      ],
      swiperOptions2: {
        slidesPerView: 'auto',
        spaceBetween: 1,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        navigation: {
          nextEl: '.r_btn',
          prevEl: '.l_btn'
        }
      },
      bottomMenu: [
        {
          Id: 0,
          name: '공지사항',
          status: true,
          url: 'notice',
          parent_id: 3
        },
        {
          Id: 0,
          name: '상품DB다운로드',
          status: true,
          url: 'productDownload',
          parent_id: 2
        },
        {
          Id: 0,
          name: '엑셀주문',
          status: true,
          url: 'orderExcel',
          parent_id: 0
        },
        {
          Id: 0,
          name: '적립금충전',
          status: true,
          url: 'point',
          parent_id: 1
        },
        {
          Id: 0,
          name: '1:1문의',
          status: true,
          url: 'qna',
          parent_id: 1
        },
        {
          Id: 0,
          name: '주문/배송조회',
          status: true,
          url: 'orderList',
          parent_id: 0
        }
      ],
      textBanner: []
    }
  },
  methods: {
    getBannerList() {
      advertiseList(1).then(res => {
        this.textBanner = res.data
      })
    },
    getProductList(e) {
      e.preventDefault()
      console.log('getProductList')
      if (!this.searchText) {
        this.$fire({ text: '검색어를 입력해 주세요.' })
      } else if (this.searchText.length < 2) {
        this.$fire({ text: '검색어를 2자 이상 입력해 주세요.' })
      } else {
        // 중복은 SKIP
        if (
          this.searchWordList.filter(word => word === this.searchText)
            .length === 0
        ) {
          this.searchWordList.unshift(this.searchText)
          if (this.searchWordList.length > 7) {
            this.searchWordList.pop()
          }
          this.$cookies.set(
            'searchWordList',
            JSON.stringify(this.searchWordList),
            '1d'
          )
        }
        // state 검색 정보 넣기
        this.setSearchParams({ text: this.searchText })

        // 상품목록으로 이동
        this.$router.push({
          name: 'productList',
          params: { search: this.searchText }
        })
        // 최근 검색어 레이어 숨기기
        this.showSearchWrods = false
      }
    },
    closeAllMenu(categoryName) {
      // state 검색 정보 넣기
      this.setSearchParams({ categoryName: categoryName })
      this.showAllMenu = false
    },
    setSearchParams(params) {
      const copyParams = this.searchParams
      if (params.text) {
        // 검색어 있으면 카테고리 초기화
        this.$set(copyParams, 'text', params.text)
        this.$set(copyParams, 'categoryName', '')
        this.$set(copyParams, 'subject', undefined)
      } else if (params.categoryName) {
        // 카테고리 있으면 검색어 초기화
        this.$set(copyParams, 'text', '')
        this.$set(copyParams, 'categoryName', params.categoryName)
        this.$set(copyParams, 'subject', undefined)
        this.searchText = ''
      }
      this.$store.dispatch('SEARCH_PARAMS', copyParams)
    },
    deleteSearchWord(index) {
      this.$delete(this.searchWordList, index)
      this.$cookies.set(
        'searchWordList',
        JSON.stringify(this.searchWordList),
        '1d'
      )
    },
    emptySearchWord() {
      this.searchWordList = []
      this.$cookies.set(
        'searchWordList',
        JSON.stringify(this.searchWordList),
        '1d'
      )
    },
    updateCategoryClass(index) {
      this.activeCategoryIndex = index
      this.treeCategories.map((category, index) => {
        category.isOn = this.activeCategoryIndex === index
      })
      this.treeCategories.splice(0, 0)
      this.changAllMenuWidth()
    },
    getTreeCategoryList() {
      fetchTreeList().then(response => {
        this.treeCategories = response.data
        if (this.treeCategories)
          this.treeCategories.map(category => {
            category.menuIcon = loadImage(category.menuIcon)
            category.onIcon = loadImage(
              category.icon.replace('.png', '_on.png')
            )
            category.icon = loadImage(category.icon)
            category.loopCount = Math.ceil(category.children.length / 5)
            return category
          })
      })
    },
    changAllMenuWidth() {
      const count = this.treeCategories[this.activeCategoryIndex].loopCount
      this.allMenuWidth = 500 + (count > 1 ? (count - 1) * 210 : 0)
    },
    matchHeight() {
      this.$emit('update:fixedHeight', this.$refs.fixedHeader.clientHeight)
    }
  },
  mounted() {
    this.matchHeight()
  },
  created() {
    this.searchText = this.searchParams.text || ''
    this.getTreeCategoryList()
    this.getBannerList()
    if (this.$cookies.isKey('searchWordList'))
      this.searchWordList = JSON.parse(this.$cookies.get('searchWordList'))
  },
  watch: {
    searchParams: {
      handler(data) {
        this.searchText = data.text
      },
      deep: true
    },
    $route(to) {
      if (to.name !== 'productList') {
        this.searchText = ''
      }
    }
    // treeCategories: {
    //   handler(data) {
    //     // console.info(data)
    //   },
    //   deep: true
    //   immediate: true // 컴포넌트가 생성되자마자 즉시 실행
    // },
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.gnb_sl .swiper-container {
  padding: 0px 10px;
}

/* my page*/
div.mp {
  cursor: pointer;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 200px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Header/FixedHeader.vue